import request from '../../utils/request'
import prefix from '../prefix'
import auth from '../auth'

/***
 * 获取极速交易配置
 * @param data
 * @returns {AxiosPromise}
 */
export const vcTimingTradeConfig = data => {
  return request({
    url: prefix + auth + '/vc-timing-trade-config/list',
    method: 'post',
    data
  })
}

/***
 * 极速交易 下单
 * @param data
 * @returns {AxiosPromise}
 */
export const vcTimingTradeRequest = data => {
  return request({
    url: prefix + auth + '/vc-timing-trade/request',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/vcTimingTradeConfig/vcTimingTradeConfig.js